import { render, staticRenderFns } from "./PrfPackingRptov.vue?vue&type=template&id=718f9cfe"
import script from "./PrfPackingRptov.vue?vue&type=script&lang=js"
export * from "./PrfPackingRptov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports